import { Result, Button } from 'antd';

const NotFound = () => {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Lo sentimos, la página que buscas no existe."
      extra={
        <Button type="primary" onClick={() => (window.location.href = "/")}>
          Volver al inicio
        </Button>
      }
    />
  );
};

export default NotFound
